// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cnt-area[data-v-c57ef17e]{margin-top:40px}.result-list[data-v-c57ef17e]{margin-top:30px;width:100%;max-height:500px;overflow:auto;border:1px solid #ddd;padding:20px;box-sizing:border-box}.result-list .el-checkbox[data-v-c57ef17e],.result-list .el-radio[data-v-c57ef17e]{display:block;margin-bottom:20px;font-size:16px;color:#000}", ""]);
// Exports
module.exports = exports;
